import React, { ForwardRefExoticComponent, SVGProps } from 'react'

import { Star } from '@factorialco/f0-react/icons/app'
import { FormsElementTypeEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { RatingElementQuestion } from 'modules/forms/components/QuestionComponent/RatingElementQuestion'
import { Element } from 'modules/forms/lib/Element'
import { Answer, ElementData } from 'modules/forms/lib/types'

type optionsProp = {
  label: string
  scoreType: string
  description?: string
}

export class ScoreElement extends Element {
  constructor(data: ElementData) {
    super(data)
    // ugly and fast copy from getDefaultOptions to prevent circular dependencies
    // (I'm not proud of it)
    this.options = [
      {
        label: i18n.t('forms.default_rating_scale.very_low'),
        value: '1',
        id: '',
        isCorrect: false,
      },
      { label: i18n.t('forms.default_rating_scale.low'), value: '2', id: '', isCorrect: false },
      { label: i18n.t('forms.default_rating_scale.average'), value: '3', id: '', isCorrect: false },
      { label: i18n.t('forms.default_rating_scale.high'), value: '4', id: '', isCorrect: false },
      {
        label: i18n.t('forms.default_rating_scale.very_high'),
        value: '5',
        id: '',
        isCorrect: false,
      },
    ]
  }

  static create({ label, scoreType, description = '' }: optionsProp): ScoreElement {
    const el = new ScoreElement({
      label,
      description,
      mandatory: true, // Scores are always mandatory
    })
    el.lock() // Scores are always locked
    el.params.scoreType = scoreType

    return el
  }
  /**
   * Get the name of the element
   */
  getName(): string {
    return i18n.t('forms.modals.elements.rating')
  }

  /**
   * Get the type of the element
   */
  getType(): FormsElementTypeEnum {
    return 'score'
  }
  /**
   * Get the icon for the element
   */
  getIcon(): ForwardRefExoticComponent<SVGProps<SVGSVGElement>> {
    return Star
  }

  getPreviewComponent(disabled?: boolean): React.ReactNode {
    return <RatingElementQuestion element={this} disabled={disabled} />
  }

  getQuestionComponent(onChange: (answer: Answer) => void): React.ReactNode {
    return <RatingElementQuestion element={this} onChange={onChange} />
  }
}
